module.exports = __webpack_public_path__ + "img/icon_dowland.92e5a911.png";